export default __webpack_public_path__ + "fccda55bd61d680d7780e209da85534f.png";